import React from 'react';
import { Inbox } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * Standard "nothing here yet" panel — replaces ad-hoc empty-list messages
 * scattered per page. Distinct from ErrorState: this is for a real, valid
 * empty result (no data yet), not a failure.
 */
export function EmptyState({ icon: Icon = Inbox, title, description, action, className }) {
  return (
    <div
      className={cn('flex flex-col items-center justify-center text-center py-12 px-6', className)}
      data-testid="empty-state"
    >
      <div className="w-12 h-12 rounded-full bg-zinc-100 flex items-center justify-center mb-3">
        <Icon className="w-5 h-5 text-zinc-400" strokeWidth={1.8} aria-hidden="true" />
      </div>
      <p className="text-sm font-semibold text-zinc-800">{title}</p>
      {description && <p className="text-sm text-zinc-500 mt-1 max-w-sm">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export default EmptyState;
